import { render, staticRenderFns } from "./IconQuestion.vue?vue&type=template&id=165e546e"
import script from "./IconQuestion.vue?vue&type=script&lang=js"
export * from "./IconQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports